module.exports = "<div class=\"container\">\n    <div class=\"row\">\n        <span style=\"float:right;\" class=\"body-gray-base\"> {{ 'VERSION' | translate: 'FOOTERLABELS' }}: {{version}}</span>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/site-footer/site-footer.component.html
// module id = ./src/app/site-footer/site-footer.component.html
// module chunks = main